/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
export var Severity;

(function (Severity) {
  /** JSDoc */
  Severity["Fatal"] = "fatal";
  /** JSDoc */

  Severity["Error"] = "error";
  /** JSDoc */

  Severity["Warning"] = "warning";
  /** JSDoc */

  Severity["Log"] = "log";
  /** JSDoc */

  Severity["Info"] = "info";
  /** JSDoc */

  Severity["Debug"] = "debug";
  /** JSDoc */

  Severity["Critical"] = "critical";
})(Severity || (Severity = {}));

export var SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];